import { render, staticRenderFns } from "./qualitySituationList-add-or-update.vue?vue&type=template&id=4888c0d3&scoped=true"
import script from "./qualitySituationList-add-or-update.vue?vue&type=script&lang=js"
export * from "./qualitySituationList-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./qualitySituationList-add-or-update.vue?vue&type=style&index=0&id=4888c0d3&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4888c0d3",
  null
  
)

export default component.exports